if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    if (document.getElementById("ot-sdk-btn") && document.getElementById("tertiary-navigation")) {
        document.getElementById("tertiary-navigation").appendChild(document.getElementById("ot-sdk-btn"))
    }

    document.documentElement.style.setProperty("--footer-offset", (document.getElementById("footer").nextElementSibling.clientHeight || 0) + 'px');

    $('.sym-slides').slick({
        accessibility: true
    });
    $('.sym-counter').slick();

    $('.press-carousel-slider').slick({
        accessibility:false,
        slidesToShow:3,
        centerMode:true,
        slidesToSlide:1,
        focusOnSelect:true,
        responsive: [
            {
              breakpoint: 1000,
              settings: {
                  slidesToShow:1,
                  centerMode:false,
                  adaptiveHeight:true
              }
            }
        ]
    })

    if(document.getElementById('contactSignup')){
        document.getElementById('contactSignup').addEventListener('click', function(){
            animateTo('footer')
        })
    }

})();



//animation of scroll vanilla JS
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}